import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

const workingGroupSpeakers = [
  'Ana Kroflič (ana.kroflic@ki.si)',
  'Luca Ferrero (luca.ferrero@unimib.it)',
];

const workingGroups = [
  {
    title: 'WG1 – Aerosol Technology',
    href: 'https://www.info.gaef.de/working-group-1',
    members: [
      'Andreas Guentner',
      'Anne Maisser',
      'Georgia Kastrinaki',
      <>
        <strong>Georgios Kelesidis, Chair</strong>{' '}
        <a
          href="mailto:g.kelesidis@tudelft.nl"
          aria-label="Email Georgios Kelesidis"
          title="Email Georgios Kelesidis"
        >
          <i className="bi bi-envelope ms-1" aria-hidden="true"></i>
        </a>
      </>,
      'Ismael Ortega',
      'Luewton Lemos F. Agostinho',
      'Michal Voitisek-Lom',
      'Mohsen Kazemimanesh',
      'Timothy Sipkens',
      'Una Trivanovic',
      'Vasiliki Tsikourkitoudi',
    ],
  },
  {
    title: 'WG2 – Atmospheric Aerosol Studies',
    href: 'https://www.info.gaef.de/working-group-2',
    members: [
      'Alexander Vogel',
      'Ana Kroflič',
      'André Prevot',
      <>
        <strong>Daniele Contini, Chair</strong>{' '}
        <a
          href="mailto:d.contini@isac.cnr.it"
          aria-label="Email Daniele Contini"
          title="Email Daniele Contini"
        >
          <i className="bi bi-envelope ms-1" aria-hidden="true"></i>
        </a>
      </>,
      'Jack Lin',
      'James Allan',
      'Julia Schmale',
      'Luca Ferrero',
      'Roland Schrödner',
      'Silvia Henning',
      'Tuomo Nieminen',
    ],
  },
  {
    title: 'WG3 – Aerosol Measurement Techniques',
    href: 'https://www.info.gaef.de/working-group-3',
    members: [
      'Amel Kort',
      'Andreas Held',
      'Attila Nagy',
      'Carsten Kykal',
      <>
        <strong>Christof Asbach, Chair</strong>{' '}
        <a
          href="mailto:asbach@iuta.de"
          aria-label="Email Christof Asbach"
          title="Email Christof Asbach"
        >
          <i className="bi bi-envelope ms-1" aria-hidden="true"></i>
        </a>
      </>,
      'David Green',
      'Gerhard Steiner',
      'Martin Rigler',
      'Oliver F. Bischof',
    ],
  },
  {
    title: 'WG4 – Aerosols and Health',
    href: 'https://www.info.gaef.de/working-group-4',
    members: [
      'Aneta Wierzbicka',
      <>
        <strong>Christina Isaxon, Chair</strong>{' '}
        <a
          href="mailto:christina.isaxon@design.lth.se"
          aria-label="Email Christina Isaxon"
          title="Email Christina Isaxon"
        >
          <i className="bi bi-envelope ms-1" aria-hidden="true"></i>
        </a>
      </>,
      'Daniela Cesari',
      'Evangelia Diapouli',
      'Mar Viana',
      'Marianna Conte',
      'Marjut Roponen',
      'Maurizio Gualtieri',
    ],
  },
  {
    title: 'WG5 – Basic Aerosol Processes',
    href: 'https://www.info.gaef.de/working-group-5',
    members: [
      'Bernadette Rosati',
      'Dina Alfaouri',
      'Eirini Goudeli',
      <>
        <strong>Ivo Neefjes, Chair</strong>{' '}
        <a
          href="mailto:ivo.neefjes@kuleuven.be"
          aria-label="Email Ivo Neefjes"
          title="Email Ivo Neefjes"
        >
          <i className="bi bi-envelope ms-1" aria-hidden="true"></i>
        </a>
      </>,
      'Jeanne Malet',
      'Nanna Myllys',
      'Siddarth Parameswaran Iver',
    ],
  },
];

const localTeam = [
  'Ana Kroflič, Chair, National Institute of Chemistry & University of Nova Gorica',
  'Martin Šala, Co-chair, National Institute of Chemistry',
  'Monika Arnič, National Institute of Chemistry',
  'Riccardo Muolo (PhD student), National Institute of Chemistry',
  'Ajda Delić (PhD student), National Institute of Chemistry',
  'Tilen Berglez, National Institute of Chemistry & University of Ljubljana',
  'Griša Močnik, University of Nova Gorica',
  'Petra Makorič (PhD student), University of Nova Gorica',
  'David Kocman, Jožef Stefan Institute',
  'Rok Novak, Jožef Stefan Institute',
  'Cathrine Terro (PhD student), Jožef Stefan Institute',
  'Martin Rigler, Aerosol Magee Scientific',
  'Asta Gregorič, Aerosol Magee Scientific',
  'Špela Kern, Aerosol Magee Scientific',
  'Ivan Iskra, Aethlabs',
];

const internationalTeam = [
  'Christof Asbach, past GAeF president',
  'Sebastian Schmitt, past GAeF treasurer',
  'Birgit Wehner, past GAeF secretary',
  'Andreas Held, GAeF president',
  'Stefan Schumacher, GAeF treasurer',
  'Mathilde Delaval, GAeF secretary',
  'Daniele Contini, past Conference Chair',
  'Ulas Im, past WG Speaker',
  'Luca Ferrero, WG Speaker',
];

export default function InfoCommittees() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Committees"
        intro="EAC2027 is developed and organized by the local and the international organizing teams, Working Group Chairs and Co-chairs, and volunteers from the aerosol research community."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>

              <section className="info-section">
                <h2 className='h1'>Scientific committee</h2>

                <p className="info-meta">
                  <strong>Chair:</strong> Martin Rigler (
                  <a href="mailto:program@eac2027.si">program@eac2027.si</a>
                  )
                </p>

                <p>
                  The scientific programme of EAC2027 will be developed with the support of the five Working Groups of
                  the <a href="https://www.info.gaef.de/eaa#dataItem-ky0dff7e" target='_blank' rel="noreferrer">European Aerosol Assembly</a>, which collectively cover the broad spectrum of research interests within
                  the aerosol science community: Aerosol Technology (WG1), Atmospheric Aerosol Studies (WG2), Aerosol Measurement Techniques (WG3), Aerosols and Health (WG4), and Basic Aerosol Processes (WG5).
                </p>

                <p>
                  Besides, several volunteers from the community help with abstract reviews every year. Their help is
                  greatly appreciated!
                </p>

                <h2 className='mt-5'>Working Group Speakers</h2>
                <ul className="info-list">
                  {workingGroupSpeakers.map((speaker) => (
                    <li key={speaker}>{speaker}</li>
                  ))}
                </ul>

                

                <h2 className='mt-5'>Working Group Chairs and Co-chairs</h2>

                {workingGroups.map((group) => (
                  <div key={group.title}>
                    <h3>
                      <a href={group.href} target="_blank" rel="noreferrer">
                        {group.title}
                      </a>
                    </h3>
                    <ul className="info-list info-list-columns">
                      {group.members.map((member, index) => (
                        <li key={`${group.title}-${index}`}>{member}</li>
                      ))}
                    </ul>
                  </div>
                ))}


                <div className="info-note">
                  <p>
                    External reviewers: TBD
                  </p>
                </div>
              </section>

              <section className="info-section">
                <h2 className='h1'>Organizing committee</h2>

                <p className="info-meta">
                  <strong>Chair:</strong> Ana Kroflič (
                  <a href="mailto:info@eac2027.si">info@eac2027.si</a>
                  )
                  <br />
                  <strong>Co-chair:</strong> Martin Šala
                </p>

                <p>
                  EAC2027 will be organised with joint efforts of a dedicated local team and international colleagues from the <a href="https://www.info.gaef.de/eaa#dataItem-ky0dff7e" target='_blank' rel="noreferrer">European Aerosol Assembly</a>.
                </p>

                <h2 className='mt-5'>Local team</h2>
                <ul className="info-list">
                  {localTeam.map((member) => (
                    <li key={member}>{member}</li>
                  ))}
                </ul>

                <p></p>

                <h2 className='mt-5'>International team</h2>
                <ul className="info-list">
                  {internationalTeam.map((member) => (
                    <li key={member}>{member}</li>
                  ))}
                </ul>
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}